import React, { useState, useEffect } from 'react'
import "./DeactivateAccountConfirmationPage.css" 
import { useParams } from "react-router-dom"
import Footer from '../../components/Footer/Footer';
import * as translator from "../../utils/translator";
import * as http from "../../utils/http"
import goodbyeImage from "../../images/goodbye.png"
import HeaderCMS from '../../components/Headers/HeaderCMS/HeaderCMS';
import StickyNotification from '../../components/StickyNotification/StickyNotification';
import { useCustomer } from '../../customHooks/useCustomer';
const DeactivateAccountConfirmationPage = () => {
  const { logout } = useCustomer();
  const { country } = useParams();
  const { token } = useParams();
  const language = translator.getLanguageByCountry(country);
  const [pageStatus, setPageStatus] = useState<"pending" | "success" | "link_expired" | "link_already_used">("pending");
  const getPageTitle = () => {
    if (pageStatus === "success") return translator.translate(language, "default", "ConfirmationPages/deactivate_account_success");
    if (pageStatus === "link_expired") return translator.translate(language, "default", "ConfirmationPages/link_expired");
    if (pageStatus === "link_already_used") return translator.translate(language, "default", "ConfirmationPages/link_already_used");
    return null;
  }

  const [stickyNotificationDetails, setStickyNotificationDetails] = useState({ // global state for sticky handling
    show: false,
    title: "",
    content: "",
    level : "",
    showInfoIcon:true,
    refresh:false,
  });

  useEffect(() => {
    http
    .postToServer(
    `deactivate-account`,
    {
      token:token,
    },
    []
    )
    .then((response) => {
      const status = response.data.status;
      if (status === "success" || status === "link_expired" || status === "link_already_used") {
        setPageStatus(status);
        if (status === "success") logout();
      } else {
        setStickyNotificationDetails({
          show: true,
          title: "",
          content: translator.translate(language, "my_account", `stickyNotifications/error/error`),
          level: "error",
          showInfoIcon: false,
          refresh: false
        });
      }
    })
    .catch(error => {
      setStickyNotificationDetails({
        show: true,
        title: "",
        content: translator.translate(language, "my_account", `stickyNotifications/error/error`),
        level: "error",
        showInfoIcon: false,
        refresh: false
      });
    });
  }, [])

  return (
    <>
      <StickyNotification
        showNotification={stickyNotificationDetails.show}
        title={stickyNotificationDetails.title}
        onClick={() => setStickyNotificationDetails({ ...stickyNotificationDetails, show: false })}
        content={stickyNotificationDetails.content}
      />
      {country && (
        <div className="goodbye-page">
          <HeaderCMS country={country} />
          <div className="goodbye-image-container">
          <img className="goodbye-image" src={goodbyeImage} alt="Goodbye" />
          <h1 className="goodbye-title">{getPageTitle()}</h1>
          </div>
          <div>
            <Footer page="CheckoutRegister" />
          </div>
        </div>
      )}
    </>
  );
}

export default DeactivateAccountConfirmationPage;